'use client'

import classNames from 'classnames/bind'

import styles from './TopBar.module.scss'
const classes = classNames.bind(styles)

const TopBar = ({ children }) => {
    return <div className={classes('topbar-container')}>{children}</div>
}

const TopBarHeader = ({ heading, subText }) => {
    return (
        <div className={classes('title-box')}>
            <h1 className={classes('header-text')}>{heading}</h1>
            <p className={classes('sub-header-text')}>{subText}</p>
        </div>
    )
}

const TopBarButtons = ({ children }) => {
    return <div className={classes('side-buttons')}>{children}</div>
}

module.exports = {
    TopBar,
    TopBarHeader,
    TopBarButtons,
}
